export const TIPE_KELAS = ["Online", "Offline", "Hybrid"];
export const TIPE_PEMBAYARAN = ["Top-down", "Bottom-up", "Seikhlasnya"];
